module.exports = __webpack_public_path__ + "img/1-3.dd9a9212.png";